import TurndownService from 'turndown';

const turndown = new TurndownService({
  headingStyle: 'atx',
  codeBlockStyle: 'fenced',
});
turndown.addRule('linebreaks', {
  filter: 'div',
  replacement(content) {
    return `\n${content}`;
  },
});

turndown.addRule('fencepre', {
  filter: 'pre',
  replacement(content, node, options) {
    return `\n\n${options.fence}\n${content}\n${options.fence}\n\n`;
  },
});

turndown.addRule('emphasis', {
  filter: ['em', 'i'],
  replacement(content, node, options) {
    const contentTrimmed = content.replace(/^\x20+|\x20+$/gm, '');
    if (!content.trim()) {
      return contentTrimmed;
    }
    return options.emDelimiter + content + options.emDelimiter;
  },
});

turndown.addRule('bold', {
  filter: ['strong', 'b'],
  replacement(content, node, options) {
    const contentTrimmed = content.replace(/^\x20+|\x20+$/gm, '');
    if (!content.trim()) {
      return contentTrimmed;
    }
    return options.strongDelimiter + content + options.strongDelimiter;
  },
});

export default turndown;
